import React from 'react';
import { Badge, BadgeTone } from '../../../ui';

/**
 * Telephony call statuses aren't in StatusBadge's map yet, so they get a local
 * tone mapping here (shared by Logs and Call detail).
 */
const CALL_STATUS_TONES: Record<string, BadgeTone> = {
  COMPLETED: 'success',
  BRIDGED: 'warning',
  IN_PROGRESS: 'warning',
  RINGING: 'warning',
  INITIATED: 'warning',
  QUEUED: 'neutral',
  NO_ANSWER: 'danger',
  BUSY: 'danger',
  FAILED: 'danger',
  CANCELED: 'neutral',
  // Distinct from NO_ANSWER on purpose: the phone WAS picked up, just by
  // voicemail/an answering machine rather than the learner.
  NOT_CONNECTED: 'info',
  // The agent's own softphone never connected, so the learner was never dialled.
  AGENT_NOT_CONNECTED: 'danger',
};

export const CallStatusBadge: React.FC<{ status: string; children?: React.ReactNode }> = ({ status, children }) => (
  <Badge tone={CALL_STATUS_TONES[status] ?? 'neutral'}>{children ?? status}</Badge>
);
